import { useEffect, useState, useContext, useMemo } from 'react'
import { useTheme } from '@mui/material/styles'
import { AnimatePresence, motion, useAnimate } from 'framer-motion'
import img2 from '../../media/small/25.jpeg'
import img3 from '../../media/small/24.jpeg'
import img4 from '../../media/small/23.jpeg'
import img5 from '../../media/small/16.jpeg'
import img6 from '../../media/small/18.jpeg'
import img7 from '../../media/small/13.jpeg'
import img8 from '../../media/small/14.jpeg'
import img9 from '../../media/small/9.jpeg'

import { useInterval } from 'usehooks-ts'

export const Desk = ({}) => {
  const theme = useTheme()
  let images = [img2, img3, img4, img5, img6, img7, img8, img9]
  let count = 0

  return (
    <AnimatePresence>
      <div className='desk'>
        <div key={'b1'} className={''} style={{}}>
          <motion.img
            key={'img' + count + 'c'}
            className={'img3'}
            src={images[3]}
          />
        </div>
        <div key={'b2'} className={''}>
          <motion.img
            key={'img' + count + 'n'}
            className={'img3'}
            src={images[4]}
          />
        </div>
        <div key={'b3'} className={''}>
          <motion.img
            key={'img' + count + 'n'}
            className={'img3'}
            src={images[5]}
          />
        </div>
      </div>
    </AnimatePresence>
  )
}
